import Area from '@/components/Area';
import { Canvas, useFrame } from '@react-three/fiber';
import * as React from 'react';
import * as THREE from 'three';
import { Html, Hud, OrbitControls } from '@react-three/drei';

// Create 800 objects with random position and rotation data
const positions = [...Array(800)].map(() => ({
  position: new THREE.Vector3(40 - Math.random() * 80, 40 - Math.random() * 80, 40 - Math.random() * 80),
  rotation: new THREE.Euler(Math.random() * Math.PI * 2, Math.random() * Math.PI * 2, Math.random() * Math.PI * 2),
}));

function R3fInfo() {
  const ref = React.useRef<HTMLElement>(null);
  useFrame(({ gl }) => {
    if (!ref.current) return;
    ref.current.innerText = `R3F: ${gl.info.render.calls} calls`;
  });
  return (
    <Hud>
      <Html>
        <pre>
          <code ref={ref}></code>
        </pre>
      </Html>
    </Hud>
  );
}

export type Props = {};

function App01(props: Props) {
  const {} = props;

  return (
    <Area>
      {() => (
        <Canvas>
          <ambientLight intensity={1} />
          {/* <R3fInfo /> */}
          {positions.map(({ position, rotation }, i) => (
            <mesh key={i} {...props} position={position} rotation={rotation}>
              <boxGeometry args={[1, 1, 1]} />
              <meshStandardMaterial color="orange" />
            </mesh>
          ))}
          <OrbitControls />
          <axesHelper args={[100]} />
        </Canvas>
      )}
    </Area>
  );
}

export default React.memo(App01);
